import { Flex } from "antd";
import type { ComponentType, SVGProps } from "react";
import type { IPublicCourseResponse } from "../../../../app/features/courses/courses.types";
import CertificateIcon from "../../../../assets/icons/CertificateIcon";
import DepartmentIcon from "../../../../assets/icons/DepartmentIcon";
import TimeIcon from "../../../../assets/icons/TimeIcon";
import WebBrowserIcon from "../../../../assets/icons/WebBrowserIcon";
import type { TBreadcrumb } from "../../../../components/Breadcrumb";
import CourseDetailsHeaderLoading from "../../../../components/ui/course-details/HeaderLoading";
import { cn } from "../../../../utils/global.utils";
import WebBreadcrumb from "./web-breadcrumb";

type Props = {
  className?: string;
  breadcrumb: TBreadcrumb[];
  course?: IPublicCourseResponse;
  isLoading?: boolean;
};

export default function WebCourseDetailsHeader({
  className,
  breadcrumb,
  course,
  isLoading,
}: Props) {
  return (
    <header
      className={cn("bg-[#E9F2F2] md:h-64 py-6 md:py-0 relative ", className)}
    >
      <Flex
        align="center"
        className="grid grid-cols-12 gap-6 mini-container container h-full"
        wrap
      >
        <div className="col-span-12 lg:col-span-8">
          <WebBreadcrumb breadcrumb={breadcrumb} className="!justify-start" />
          {isLoading ? (
            <CourseDetailsHeaderLoading />
          ) : (
            <>
              <h1 className="text-theme-zinc-700 text-2xl lg:text-3xl font-medium mt-5 mb-4">
                {course?.title}
              </h1>
              <div>
                <Item
                  icon={DepartmentIcon}
                  title="বিভাগ:"
                  value={course?.Category?.name || ""}
                />

                <Flex align="center" gap={16} wrap className="mt-4">
                  <Item
                    icon={TimeIcon}
                    iconClassName="text-xl text-theme-error-300"
                    title="সময়:"
                    value={course?.durationLabel || ""}
                  />
                  <Item
                    icon={WebBrowserIcon}
                    iconClassName="text-xl text-theme-error-300"
                    title="ভাষা:"
                    value={course?.language || "-"}
                  />
                  {!!course?.isCertificateEnabled && (
                    <Item
                      icon={CertificateIcon}
                      iconClassName="text-xl text-theme-error-300"
                      value="সমাপ্তির পর সার্টিফিকেট"
                    />
                  )}
                </Flex>
              </div>
            </>
          )}
        </div>
      </Flex>
    </header>
  );
}

type TItem = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  iconClassName?: string;
  title?: string;
  value: string;
};
const Item = ({ icon: Icon, iconClassName, title, value }: TItem) => (
  <Flex align="center">
    <Icon className={cn("relative -top-[1px] mr-3", iconClassName)} />
    {!!title && (
      <span className="text-theme-zinc-700 text-sm lg:text-base font-medium mr-2">
        {title}
      </span>
    )}
    <span className="text-theme-zinc-700 text-sm lg:text-base font-normal">
      {value}
    </span>
  </Flex>
);
